var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.554 3.2a1.727 1.727 0 0 1 1.846.403l.01.01c.445.453.651 1.14.393 1.836l-5.456 14.72c-.598 1.613-2.92 1.485-3.34-.184l-1.598-6.381-6.397-1.607c-1.616-.405-1.785-2.595-.33-3.276l.147-.061zm.405 2.908-7.1 7.11 1.603 6.402a.251.251 0 0 0 .446.09l.033-.063 5.018-13.54zM17.905 5.04 4.35 10.066a.25.25 0 0 0 .026.477l6.422 1.613 7.106-7.116z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlane);
export default __webpack_public_path__ + "static/media/icons-plane.5102cff4ff7c2e2e53532163f92dffb5.svg";
export { ForwardRef as ReactComponent };